import React from 'react'
import { useRouter } from 'next/router'

import Layout from 'components/shared/Layout'
import CardsGrid from 'components/shared/CardsGrid'
import ListCardContent from 'components/shared/CardWithArrowLink/ListCardContent'
import { CardWithArrowLinkProps } from 'components/shared/CardWithArrowLink'
import WhiteHero from 'components/shared/WhiteHero'

import css from './styles.module.scss'

const IntegrationTopics = ({ topics, integration }) => {
  const router = useRouter()
  const currentUrl = router.asPath

  const whiteHero = {
    intro: {
      theme: 'purple',
      label: 'Learn more',
      title: `Unlock powerful ${integration} concepts!`,
      smallTextWithLink: [],
      newsWithLink: null,
    },
  }

  const customCardProps = CardWithArrowLinkProps.customCardProps
  return (
    <Layout tag="section" type="maxWidth">
      <Layout type="wrapper">
        {whiteHero && <WhiteHero {...whiteHero} />}
        <CardsGrid
          cards={topics?.data.map((topic) => {
            return {
              ...topic?.attributes,
              link: {
                href: `${currentUrl}/topics/${topic?.attributes?.slug}`,
              },
            }
          })}
          resize
          customCardComponent={ListCardContent}
          customCardProps={{ ...customCardProps, cover: { size: 'large' } }}
        />
      </Layout>
    </Layout>
  )
}

IntegrationTopics.defaultProps = {}

export default IntegrationTopics
